import {Action} from '@ngrx/store';
import {IAvail, ISalesAppointmentForm, SeriesDetailsForYear} from './sales-appointment.reducer';
import {VehicleColor} from './../../shared/models/series-data';
import {IAppointment, ICustomer, IAvailabilityOptions, IAvailability, AppointmentType, IVehicle, IGeneralSettingsAppointmentRequest} from '@signal/asp-data-commons';

export enum SalesAppointmentActionTypes {
  UPDATE_SALES_FORM_DATA = '[Sales page] sales form data updated in state',
  UPDATE_SALES_AVAILABILITY_DATA = '[Sales page] sales availability data updated in state',
  UPDATE_PATCH_SALES_FORM = '[Sales page] update sales vehicle or any value as per given path',
  CREATE_SALES_APPOINTMENT = '[Sales page] create sales Appointment',
  CREATE_SALES_APPOINTMENT_SUCCESS = '[Sales page] create sales Appointment success',
  CREATE_SALES_APPOINTMENT_FAILURE = '[Sales page] create sales Appointment failure',
  GET_EDIT_DATA = '[Sales page] fetching edit details from DB',
  GET_EDIT_DATA_SUCCESS = '[Sales page] fetching edit details from DB success',
  GET_EDIT_DATA_FAILURE = '[Sales page] fetching edit details from DB failure',
  EDIT_SALES_APPOINTMENT = '[Sales page] edit sales Appointment',
  EDIT_SALES_APPOINTMENT_SUCCESS = '[Sales page] edit sales Appointment success',
  EDIT_SALES_APPOINTMENT_FAILURE = '[Sales page] edit sales Appointment failure',
  LOAD_AVAILABILITY_OPTIONS = '[Sales page] load Availability options',
  LOAD_AVAILABILITY_OPTIONS_SUCCESS = '[Sales page] load Availability options success',
  LOAD_AVAILABILITY_OPTIONS_FAILURE = '[Sales page] load Availability options failure',
  LOAD_AVAILABILITY = '[Sales page] load Availability',
  LOAD_AVAILABILITY_SUCCESS = '[Sales page] load Availability success',
  LOAD_AVAILABILITY_FAILURE = '[Sales page] load Availability failure',
  LOAD_SERIES_TRIM = '[EFC API] load Series and Trim details from EFC',
  LOAD_SERIES_TRIM_SUCCESS = '[EFC API] load Series and Trim details from EFC success',
  LOAD_SERIES_TRIM_FAILURE = '[EFC API] load Series and Trim details from EFC failure',
  LOAD_EXTERIOR_COLORS = '[EFC API] load Exterior colors details from EFC',
  LOAD_EXTERIOR_COLORS_SUCCESS = '[EFC API] load Exterior colors details from EFC success',
  LOAD_EXTERIOR_COLORS_FAILURE = '[EFC API] load Exterior colors details from EFC failure',
  RESET_SALES_APPOINTMENT_STATE = '[Sales page] reset Sales Appointment State',
  RESET_SALES_APPOINTMENT_FORM = '[Sales page] reset form value in State while routing',
  RESET_EXTERIOR_COLOR = '[Sales page] reset exterior color details while changing model',
  LOAD_CUSTOMER_DETAILS = '[Sales page] load signed in customer details in initial state',
  UPDATE_CUSTOMER_FORM_TRANSPORT = '[Sales page] Update Transport for Quick Reschedule',
  LOAD_TESTDRIVE_VIN_VEHICLE = '[EFC API] load color and vehicle details',
  LOAD_TESTDRIVE_VIN_VEHICLE_SUCCESS = '[EFC API] load color and vehicle details success',
  LOAD_TESTDRIVE_VIN_VEHICLE_FAILURE = '[EFC API] load color and vehicle details fail',
  LOAD_ALL_SERIES_TRIM = '[EFC API] load all Series and Trim details from EFC',
  LOAD_ALL_SERIES_TRIM_SUCCESS = '[EFC API] load all Series and Trim details from EFC success',
  LOAD_ALL_SERIES_TRIM_FAILURE = '[EFC API] load all Series and Trim details from EFC failure',
  CREATE_CHECKLIST = '[EFC API] Populate checklist',
  TRIGGER_LOADING = '[ASP API] Trigger Checklist Requests Loader',
  TRIGGER_LOADING_FAIL = '[ASP API] Stop Trigger Checklist Requests Loader',
  SEND_LINK_TO_CUSTOMER = '[Sales page] Send appointment link to customer',
  SEND_LINK_TO_CUSTOMER_SUCCESS = '[Sales page] Send appointment link to customer success',
  SEND_LINK_TO_CUSTOMER_FAILURE = '[Sales page] Send appointment link to customer failure',
  UPDATE_SENT_LINK_DATE = '[Sales page] update sent link date',
  UPDATE_CURRENT_STEP = '[Sales page] Update current step',
  LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK = '[SALES page] Load SALES Appointment details from signal deeplink',
  LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK_SUCCESS = '[SALES page] Load SALES Appointment details from signal deeplink Success',
  LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK_FAIL = '[SALES page] Load SALES Appointment details from signal deeplink Fail'
}

export class UpdateSalesFormData implements Action {
  readonly type: string = SalesAppointmentActionTypes.UPDATE_SALES_FORM_DATA;

  constructor(public payload: { value: ISalesAppointmentForm, appointmentType?: string }) {
  }
}

export class UpdatePatchSalesForm implements Action {
  readonly type: string = SalesAppointmentActionTypes.UPDATE_PATCH_SALES_FORM;

  constructor(public payload: { path: string, value: IVehicle | any }) {
  }
}
export class UpdateSalesAvailabilityData implements Action {
  readonly type : string = SalesAppointmentActionTypes.UPDATE_SALES_AVAILABILITY_DATA;

  constructor(public payload : {value : IAvail}){
    
  }
}
export class UpdateCustomerFormTransport implements Action {
  readonly type: string = SalesAppointmentActionTypes.UPDATE_CUSTOMER_FORM_TRANSPORT;

  constructor(public payload: { transportData: any }) {
  }
}
export class CreateSalesAppointment implements Action {
  readonly type: string = SalesAppointmentActionTypes.CREATE_SALES_APPOINTMENT;

  constructor(public payload: { appointmentType: AppointmentType,settings:IGeneralSettingsAppointmentRequest, requestAppSrc?: string, from?:string, searchWithVin?:boolean, retryAttempt?: number}) {
  }
}

export class CreateSalesAppointmentSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.CREATE_SALES_APPOINTMENT_SUCCESS;

  constructor(public payload: { appointmentModel: IAppointment }) {
  }
}

export class CreateSalesAppointmentFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.CREATE_SALES_APPOINTMENT_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class updateSentLinkDate implements Action{
  readonly type: string = SalesAppointmentActionTypes.UPDATE_SENT_LINK_DATE;
  constructor() {
  }
}

export class SendLinkToCustomer implements Action{
  readonly type: string = SalesAppointmentActionTypes.SEND_LINK_TO_CUSTOMER;
  constructor(public payload: { appointmentIds: string[], appointment:IAppointment }) {
  }
}

export class SendLinkToCustomerSuccess implements Action{
  readonly type: string = SalesAppointmentActionTypes.SEND_LINK_TO_CUSTOMER_SUCCESS;
  constructor(public payload: { value: any }) {
  }
}

export class SendLinkToCustomerFailure implements Action{
  readonly type: string = SalesAppointmentActionTypes.SEND_LINK_TO_CUSTOMER_FAILURE;
  constructor(public payload: { error: string }) {
  }
}

export class GetEditData implements Action {
  readonly type: string = SalesAppointmentActionTypes.GET_EDIT_DATA;

  constructor(public payload: { appointmentType: AppointmentType, appointmentId: string }) {
  }
}

export class GetEditDataSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.GET_EDIT_DATA_SUCCESS;

  constructor(public payload: { appointmentModel: IAppointment }) {
  }
}

export class GetEditDataFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.GET_EDIT_DATA_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class EditSalesAppointment implements Action {
  readonly type: string = SalesAppointmentActionTypes.EDIT_SALES_APPOINTMENT;

  constructor(public payload: { appointmentType: AppointmentType,settings:IGeneralSettingsAppointmentRequest,searchWithVin?:boolean, retryAttempt?: number }) {
  }
}

export class EditSalesAppointmentSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.EDIT_SALES_APPOINTMENT_SUCCESS;

  constructor(public payload: { appointmentModel: IAppointment }) {
  }
}

export class EditSalesAppointmentFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.EDIT_SALES_APPOINTMENT_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadAvailability implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_AVAILABILITY;

  constructor(public payload: {selectDateAndSlot: boolean, date: string, advisorId: string, fniAdvisorId?: string,
     transport: string, vin?: string, appointmentType?: string, checklistDuration?: { min: number; }, override?: {allow: boolean, date: ''},appointmentId: string} = 
     {selectDateAndSlot: true, date: '', advisorId: '-1', fniAdvisorId: '-1', transport:undefined, vin:'', appointmentType:'', override: {allow: false, date: ''},appointmentId:''}) {
  }
}

export class LoadAvailabilitySuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_AVAILABILITY_SUCCESS;

  constructor(public payload: { availability: IAvailability, loadPayload: {date: string, advisorId: string, fniAdvisorId?: string, transport: string, selectDateAndSlot?: boolean}}) {
  }
}

export class LoadAvailabilityFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_AVAILABILITY_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadAvailabilityOptions implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_AVAILABILITY_OPTIONS;

  constructor(public payload: {appointmentType: string}) {
  }
}

export class LoadAvailabilityOptionsSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_AVAILABILITY_OPTIONS_SUCCESS;

  constructor(public payload: { availabilityOptions: IAvailabilityOptions }) {
  }
}

export class LoadAvailabilityOptionsFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_AVAILABILITY_OPTIONS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadSeriesAndTrim implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_SERIES_TRIM;

  constructor() {
  }
}

export class LoadSeriesAndTrimSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_SERIES_TRIM_SUCCESS;

  constructor(public payload: { seriesDetails: SeriesDetailsForYear[] }) {
  }
}

export class LoadSeriesAndTrimFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_SERIES_TRIM_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadExteriorColors implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_EXTERIOR_COLORS;

  constructor(public payload: { year: string, model: string, trim: string }) {
  }
}

export class LoadExteriorColorsSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_EXTERIOR_COLORS_SUCCESS;

  constructor(public payload: { exteriorColors: VehicleColor[] }) {
  }
}

export class LoadExteriorColorsFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_EXTERIOR_COLORS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ResetSalesAppointmentForm implements Action {
  readonly type: string = SalesAppointmentActionTypes.RESET_SALES_APPOINTMENT_FORM;

  constructor() {
  }
}

export class ResetSalesAppointmentState implements Action {
  readonly type: string = SalesAppointmentActionTypes.RESET_SALES_APPOINTMENT_STATE;

  constructor() {
  }
}

export class ResetExteriorColors implements Action {
  readonly type: string = SalesAppointmentActionTypes.RESET_EXTERIOR_COLOR;

  constructor() {
  }
}

export class LoadCustomerDetails implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_CUSTOMER_DETAILS;

  constructor(public payload: { signedInUserDetails: ICustomer }) {
  }
}
export class LoadTestDriveVinVehicle implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_TESTDRIVE_VIN_VEHICLE;

  constructor(public payload: { vehicle: IVehicle }) {
  }
}
export class LoadTestDriveVinVehiclecSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_TESTDRIVE_VIN_VEHICLE_SUCCESS;

  constructor(public payload: { data: any }) {
  }
}
export class LoadTestDriveVinVehiclecFailure implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_TESTDRIVE_VIN_VEHICLE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}
export class CreateChecklist implements Action {
  readonly type: string = SalesAppointmentActionTypes.CREATE_CHECKLIST;

  constructor(public payload: { data: any }) {
  }
}

export class UpdateCurrentStep implements Action {
  readonly type: string = SalesAppointmentActionTypes.UPDATE_CURRENT_STEP;

  constructor(public payload: { step: number }) {
  }
}

export class LoadSalesAppointmentFromSignalDeepLink {
  readonly type: string = SalesAppointmentActionTypes.LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK;

  constructor(public payload: any) { }
}

export class LoadSalesAppointmentFromSignalDeepLinkSuccess implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK_SUCCESS;

  constructor(public payload: { data: any }) {
  }
}

export class LoadSalesAppointmentFromSignalDeepLinkFail implements Action {
  readonly type: string = SalesAppointmentActionTypes.LOAD_SALES_APPOINTMENT_FROM_SIGNAL_DEEP_LINK_FAIL;

  constructor(public payload: { error: string }) {
  }
}

export type SalesAppointmentType =
  UpdateSalesFormData
  | UpdatePatchSalesForm
  | CreateSalesAppointment
  | CreateSalesAppointmentSuccess
  | CreateSalesAppointmentFail
  | GetEditData
  | GetEditDataSuccess
  | GetEditDataFail
  | EditSalesAppointment
  | EditSalesAppointmentSuccess
  | EditSalesAppointmentFail
  | LoadAvailabilityOptions
  | LoadAvailabilityOptionsSuccess
  | LoadAvailabilityOptionsFail
  | LoadSeriesAndTrim
  | LoadSeriesAndTrimSuccess
  | LoadSeriesAndTrimFail
  | LoadExteriorColors
  | LoadExteriorColorsSuccess
  | LoadExteriorColorsFail
  | ResetSalesAppointmentState
  | ResetSalesAppointmentForm
  | ResetExteriorColors
  | LoadCustomerDetails
  | CreateChecklist
  | UpdateCurrentStep
  | SendLinkToCustomer
  | SendLinkToCustomerSuccess
  | SendLinkToCustomerFailure